import type { FC, PropsWithChildren } from "react";
import { memo } from "react";
import { Header, Breadcrumbs, Sidebar } from "@src/components";
import { StyledLayout } from "./layout.styles";
import { useLocation } from "react-router-dom";
import { Container } from "@src/core/styles";
import { LayoutWithSidebar, MainContent } from "@src/components/sidebar/sidebar.styles";

export const Layout: FC<PropsWithChildren> = memo(({ children }) => {
  const { pathname } = useLocation();
  const showBreadcrumbs =
    pathname.startsWith("/workspace") ||
    pathname.startsWith("/settings") ||
    pathname.startsWith("/connect") ||
    pathname.startsWith("/log") ||
    pathname === "/logs";

  const showSidebar =
    !pathname.startsWith("/login") &&
    !pathname.startsWith("/registration") &&
    !pathname.startsWith("/recovery-password");

  return (
    <>
      <Header />
      <LayoutWithSidebar>
        {showSidebar && <Sidebar />}
        <MainContent>
          <StyledLayout pathname={pathname}>
            {showBreadcrumbs && (
              <Container>
                <Breadcrumbs />
              </Container>
            )}
            <main>{children}</main>
          </StyledLayout>
        </MainContent>
      </LayoutWithSidebar>
    </>
  );
});
